import React, { useEffect, useState } from "react";
import { PackageRecord } from "../entities/PackageRecord";
import { List, Button } from "antd";
import './PackageHistoryPage.css';
import { ServiceInfo } from "../entities/ServiceInfo";
import { DEPLOY_ENV } from "../utils/config";
import { DeployStateExt } from "../enums/DeployState";
import PackageService from "../http/PackageService";
import DateFormatUtils from "../utils/DateFormatUtils";

interface PackageHistoryPageProps {
    service: ServiceInfo;
}

const PackageHistoryPage: React.FC<PackageHistoryPageProps> = ({ service }) => {
    const [packageRecords, setPackageRecords] = useState<PackageRecord[]>([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [totalRecords, setTotalRecords] = useState(0);

    useEffect(() => {
        PackageService.listPackageRecords({ appKey: service.appKey, env: DEPLOY_ENV, page: { pageNum, pageSize }}).then((response) => {
            if (response.isFailed()) {
                return;
            }
            setPackageRecords(response.data.list || []);
            setTotalRecords(response.data.page.totalCount || 0);
        });
    }, [service.appKey, pageNum, pageSize]);

    const handleItemClick = (id: number) => {
        window.open(`/detail/package?id=${id}`, '_blank');
    };

    const handlePageChange = (page: number, size?: number) => {
        setPageNum(page);
        if (size) {
            setPageSize(size);
        }
    };

    return (
        <div className="package-history-page">
            <List
                itemLayout="horizontal"
                dataSource={packageRecords}
                renderItem={record => (
                    <List.Item
                        actions={[<Button type="link" onClick={() => handleItemClick(record.id)}>查看详情</Button>]}
                    >
                        <List.Item.Meta
                            title={`包名: ${record.packageName}`}
                            description={
                                <>
                                    <div>创建时间: {DateFormatUtils.format(record.createTime)}</div>
                                    <div className="text-block">
                                        状态：
                                        <p style={{ color: DeployStateExt.getStatusColorFromString(record.packageState) }}>
                                            {DeployStateExt.getPackageStateTextFromString(record.packageState)}
                                        </p>
                                    </div>
                                </>
                            }
                        />
                    </List.Item>
                )}
                pagination={{
                    current: pageNum,
                    pageSize: pageSize,
                    total: totalRecords,
                    onChange: handlePageChange,
                    showSizeChanger: true,
                    pageSizeOptions: ['20']
                }}
            />
        </div>
    );
};

export default PackageHistoryPage;